import { Component, ChangeDetectionStrategy, OnInit } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { map, Observable } from "rxjs";

@Component({
  standalone: false,
    selector: "formly-field-custom-combobox",
    templateUrl: "./custom-combobox.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldCustomCombobox extends FieldType<FieldTypeConfig> implements OnInit {

    fieldModel: any = {};

    ngOnInit(): void {

        const value = this.model[this.props.valueKey]
        const label = this.model[this.props.labelKey]

        this.fieldModel = { value: value, label: label };
    }

    override defaultOptions = {
        props: {
            allowCustom: false,
            valuePrimitive: true,
        },
    };

    public valueNormalizer = (text: Observable<string>) =>
        text.pipe(
            map((content: string) => {
                return {
                    value: null,
                    label: content
                };
            })
        );

}
